import BaseAPI from './base'

class GroupAlertFieldAPI extends BaseAPI {
  constructor() {
    super()
    this.client.defaults.baseURL = `${this.fleetURL}/backoffice`
  }

  getGroupAlertFields = (query) =>
    this.client.get(`group-alert-fields?${query}`)

  updateGroupAlertField = ({ groupAlertFieldId, payload }) =>
    this.client.patch(`group-alert-fields/${groupAlertFieldId}`, payload)
}

export default new GroupAlertFieldAPI()
